import classic from 'ember-classic-decorator';

import ApplicationSerializer from './application';

@classic
export default class UserSerializer extends ApplicationSerializer {
  attrs = {
    metaAdUser: { embedded: 'always' }
  };
}
